const Config = {
    cdnOverride: true,
    urls: {
        baseUrl: 'https://cryo.host/',
        clientAreaUrl: 'https://my.cryo.host/',
        cdnBaseUrl: 'http://cryo.host/',

        support: 'https://my.cryo.host/supporttickets.php',
        globalParams: {
            // gid:
        }
    },
    files: {
    },
    emails: {
        support: "support@cryo.host",
        billing: "billing@cryo.host",
        legal: "legal@cryo.host"
    },
    environment: process.env.NODE_ENV,
};

// Prevent modifications to the object
Object.freeze(Config);

export default Config;